/**
 * Creates a throttled function that delays invoking "callback" until after "timeout" milliseconds.
 * Timeout default = 1000 (ms) / 60 (frames) = 16.6667;
 * @param callback function be delayed
 * @param timeout time to wait (milliseconds)
 * @returns throttled function
 */
const throttle = function (callback: Function, timeout = 16.6667) {
  let waiting: any = false;
  return (...args: any[]): void => {
    if (waiting) {
      return;
    }

    clearTimeout(waiting);
    waiting = setTimeout(() => {
      callback(...args);
      waiting = false;
    }, timeout);
  };
};

export default throttle;
